export default __webpack_public_path__ + "static/autoglyphs-23f28cd27917f7d6b20e8f6b807775c2.png";